import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import useCreateSecret from "../service/useCreateSecret";

export type CreateSecretForm = {
	password: string;
	name: string;
};

export default function useCreateSecretForm() {
	const { translate } = useLocales();

	const schema = Yup.object().shape({
		password: Yup.string().required(translate("app_secrets.add_password")),
		name: Yup.string().required(translate("app_secrets.add_your_name"))
	});

	const methods = useForm<CreateSecretForm>({
		resolver: yupResolver(schema),
		defaultValues: { password: "" }
	});

	const onIncorrectPassword = () => {
		methods.setError("password", { message: translate("app_secrets.incorrect_password") });
	};

	const { onCreateSecret, isLoading } = useCreateSecret({ onIncorrectPassword });

	async function onSubmit({ name, password }: CreateSecretForm) {
		onCreateSecret(name, password);
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading
	};
}
